import { eventTypes } from '@/main.config'

export const subscribeMobileEventsMultiple = {
  data: () => ({
    stack: {},
    canSubscribe: false,
    isThrottled: false,
    ms: 700
  }),
  computed: {
    isSocketAuth() {
      return this.$store.getters.IS_SOCKET_AUTH
    }
  },
  watch: {
    canSubscribe() {
      if (this.canSubscribe && this.isSocketAuth) {
        this.subscribe()
      } else if (!this.canSubscribe) {
        this.unsubscribe()
      }
    }
  },
  created() {
    if (this.canSubscribe && this.isSocketAuth) {
      this.subscribe()
    }
  },
  beforeDestroy() {
    this.unsubscribe()
  },
  methods: {
    subscribe() {
      this.sockets.subscribe('api/mobile-events created', event => {
        this.directChange(event)
      })
    },
    unsubscribe() {
      this.sockets.unsubscribe('api/mobile-events created')
    },
    addToStack(event) {
      let key = event.tr_id + event.type
      if (event.type === eventTypes.cardioEvent) {
        key = event.tr_id + event.episodeType
      }
      this.stack[key] = event
    },
    removeFromStack(event) {
      let key = event.tr_id + event.type
      if (event.type === eventTypes.cardioEvent) {
        key = event.tr_id + event.episodeType
      }
      delete this.stack[key]
    },
    removeFromStackAllForTraining(id) {
      // eslint-disable-next-line no-unused-vars
      for (let key in this.stack) {
        if (key.indexOf(id) === 0) {
          this.removeFromStack(this.stack[key])
        }
      }
    },
    directChange(event) {
      this.changeDataByEvent(event)
    },
    throttledChange(event) {
      if (this.isThrottled) {
        this.addToStack(event)
        return
      }

      this.isThrottled = true

      this.changeDataByEvent(event)
      this.removeFromStack(event)

      setTimeout(this.delayedChange.bind(this), this.ms)
    },
    delayedChange() {
      this.isThrottled = false
      // eslint-disable-next-line no-unused-vars
      for (let key in this.stack) {
        this.changeDataByEvent(this.stack[key])
        this.removeFromStack(this.stack[key])
      }
    }
    //function changeDataByEvent(event) must be in every component that uses this mixin
  }
}
